/** Accruals surfaces stay hidden unless client_master_v2.accrualsbotEnabled is exactly true. */

export function isAccrualsSurfacePath(path) {
  const value = String(path || '');
  return value.includes('/automationaccruals')
    || value.startsWith('/platform/console')
    || value.startsWith('/platform/accruals-settings');
}
